/* eslint-disable no-restricted-imports */
import { OrderItem } from '@/data/types/Order';
import { findExtendedAttributes } from 'integration/utils/findExtendedAttributes';
import { useMemo } from 'react';

type AttributeKeys = {
	personalizationNumber?: string;
	personalizationName?: string;
};

export const useOrderItemCustom = (
	orderItem: OrderItem,
	attributeKeys: AttributeKeys = {
		personalizationNumber: 'customNumber',
		personalizationName: 'customName',
	}
) => {
	const extendedAttributes = findExtendedAttributes(orderItem, attributeKeys);
	const isOrderItemCustom = useMemo(() => !!extendedAttributes.length, [extendedAttributes]);

	return {
		isOrderItemCustom,
		extendedAttributes,
	};
};
